import { render, staticRenderFns } from "./PartnerFormAccessData.vue?vue&type=template&id=4462c090&scoped=true&"
import script from "./PartnerFormAccessData.vue?vue&type=script&lang=ts&"
export * from "./PartnerFormAccessData.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerFormAccessData.vue?vue&type=style&index=0&id=4462c090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4462c090",
  null
  
)

export default component.exports